/* eslint-disable jsx-a11y/label-has-associated-control */
import React from 'react';
import { Field, InjectedFormProps, reduxForm } from 'redux-form';
import { Link } from 'react-router-dom';

import { ROUTE_PREFIX } from '../../../constants/router';
import s from './LoginForm.module.scss';
import render from '../../ReduxForm/renderField';
import getAssetLink from '../../../util/getAssetLink';

const validate = () => {
  const errors = {};
  return errors;
};

interface LoginType {
  username: string;
  password: string;
}

interface LoginFormProps {
  // eslint-disable-next-line no-unused-vars
  onSubmit: (data: any) => void;
  onCancel: () => void;
  isAdminLogin?: boolean;
  errors?: Array<string>;
}

class LoginForm extends React.Component<
  InjectedFormProps<LoginType, LoginFormProps> & LoginFormProps
> {
  static defaultProps = {
    isAdminLogin: false,
    errors: [],
  };

  render() {
    const { handleSubmit, onCancel, isAdminLogin, errors } = this.props;

    return (
      <div className={s.loginForm}>
        <div className={s.loginHeader}>
          <h1>{isAdminLogin ? 'ADMIN LOGIN' : 'LOGIN'}</h1>
          <button className={s.cancelButton} type="button" onClick={onCancel}>
            <img src={getAssetLink('cross_thin.png')} alt="abbrechen" />
          </button>
        </div>
        <form className="default-form" onSubmit={handleSubmit}>
          <fieldset>
            <label htmlFor="username">Benutzername</label>
            <Field
              id="username"
              name="username"
              type="text"
              placeholder=""
              component={render.renderInput}
            />
            <label htmlFor="password">Passwort</label>
            <Field
              id="password"
              name="password"
              type="password"
              placeholder=""
              component={render.renderInput}
            />
            {errors != null && errors.length === 0 ? null : (
              <ul style={{ padding: 0, margin: 0, listStyleType: 'none' }}>
                {errors != null &&
                  errors.map((err: any) => (
                    <li key={err} className="validationError">
                      {err}
                    </li>
                  ))}
              </ul>
            )}
            <button className={`wideButton ${s.loginButton}`} type="submit">
              ANMELDEN
            </button>
          </fieldset>
          {!isAdminLogin && (
            <div className={s.links}>
              <Link to={`${ROUTE_PREFIX}/registration`} className="link">
                REGISTRIEREN
              </Link>
            </div>
          )}
        </form>
      </div>
    );
  }
}

export default reduxForm<LoginType, LoginFormProps>({
  form: 'login',
  validate,
  pure: false,
})(LoginForm);
